<script lang="ts">
  import PlayerLevel from '$lib/players/player-level.svelte';
  import SearchGroup from './search-group.svelte';
  import SearchItem from './search-item.svelte';
  import { getContext } from 'svelte';
  import { searchResultContext, type SearchResultContext } from './search.svelte';
  import { LL, locale } from '$i18n/i18n-svelte';

  const { searchResult } = getContext<SearchResultContext>(searchResultContext);
</script>

<SearchGroup title={$LL.search.resultGroups.players()}>
  {#each $searchResult?.players.slice(0, 5) ?? [] as player}
    <SearchItem type={$LL.search.resultGroups.players()} href="/{$locale}/players/{player.name}">
      <PlayerLevel slot="icon" level={player.level} />
      {player.name}
    </SearchItem>
  {/each}
</SearchGroup>
